import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image } from 'antd';

import earn_section from '@/assets/figma/earn_section.png';
import map_globe from '@/assets/figma/map_globe.png';
import icon5 from '@/assets/icon5.png';
import icon6 from '@/assets/icon6.png';
import icon7 from '@/assets/icon7.png';
import icon8 from '@/assets/icon8.png';
import icon9 from '@/assets/icon9.png';

const getBadges = (t: (key: string) => string) => [
  { icon: icon5, text: t('regarding-badge-1') },
  { icon: icon6, text: t('regarding-badge-2') },
  { icon: icon7, text: t('regarding-badge-3') },
  { icon: icon8, text: t('regarding-badge-4') },
  { icon: icon9, text: t('regarding-badge-5') },
];

export const RegardingHybridNodes: React.FC = () => {
  const { t } = useTranslation();
  const badges = getBadges(t);

  return (
    <section id="about" className="section-page relative overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <h2 className="mb-8 text-balance text-3xl font-bold text-white sm:mb-10 text-center">{t('regarding-title')}</h2>

        {/* Section image/bg */}
        <div className="flex justify-center mb-12 relative">
          <img src={earn_section} alt="Earn" className="w-full max-w-[min(100%,48rem)] rounded-2xl" />
          <div className="grid grid-cols-2 gap-4 w-full max-w-[min(70%,30rem)] absolute md:top-20 top-8">
            <Image src={new URL('../assets/figma/book1.jpg', import.meta.url).href} alt="License" className="rounded-2xl w-full" />
            <Image src={new URL('../assets/figma/book2.jpg', import.meta.url).href} alt="License" className="rounded-2xl w-full" />
          </div>
        </div>

        <div className="relative rounded-2xl overflow-hidden my-12 md:pl-20 md:pt-14 px-6 pb-12" style={{
          backgroundImage: `url(${map_globe})`,
          backgroundSize: 'cover',
          backgroundPosition: 'top center',
          backgroundRepeat: 'no-repeat',
        }}>
          <div className="max-w-7xl mx-auto">
            {badges.map((b, i) => (
              <div key={i} className="rounded-2xl p-5 sm:p-6 flex flex-col md:flex-row gap-5">
                <img src={b.icon} className="w-12 h-12 rounded-2xl flex items-center justify-center text-2xl" />
                <p className="text-pretty text-sm leading-relaxed text-white/90">{b.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
